// extracted by mini-css-extract-plugin
export default {"referral":"referral--oEjOF","referral__header":"referral__header---ns4c","referral__header-logo":"referral__header-logo--3oBJ-","referral__title":"referral__title--1rCK2","referral__auth":"referral__auth--JhVpD","referral__notes":"referral__notes--1F_jh"};
    if(module.hot) {
      // 1747648130831
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  